import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage, useIntl } from "react-intl";
import appleLoginLogo from '../images/appleLoginLogo.svg';
import googleLoginLogo from '../images/googleLoginLogo.png';
import emailLoginLogo from '../images/emailLoginLogo.png';

function SignInBtn(props){
  const { classes, type } = props;
  const intl = useIntl();
  
  if(type === 'email'){
    return (
      <div
        className={classes.signInButton}
        style={{
            backgroundColor: "#FD9728",
        }}
      >
        <span
          className={classes.signInButtonIcon}
          style={{
              backgroundImage: `url(${emailLoginLogo})`,
          }}
        ></span>
        <span className={`${classes.signInButtonText} ${classes['signInButtonText_' + intl.locale]}`}>
            <FormattedMessage id="sign_in_with_email"></FormattedMessage>
        </span>
      </div>
    );
  } else if (type === 'apple') {
    return (
      <div className={classes.signInButton} style={{ backgroundColor: 'black' }}>
        <span
          className={classes.signInButtonIcon}
          style={{
            backgroundImage: `url(${appleLoginLogo})`,
            backgroundSize: '30px auto',
            borderRight: 'none',
          }}
        ></span>
        <span className={`${classes.signInButtonText} ${classes['signInButtonText_' + intl.locale]}`}>
          <FormattedMessage id="sign_in_with_apple"></FormattedMessage>
        </span>
      </div>
    );
  }

    return (
    <div className={classes.signInButton}>
      <span
        className={classes.signInButtonIcon}
        style={{
          backgroundImage: `url(${googleLoginLogo})`,
          backgroundColor: 'white',
        }}
      ></span>
      <span className={`${classes.signInButtonText} ${classes['signInButtonText_' + intl.locale]}`}>
        <FormattedMessage id="sign_in_with_google"></FormattedMessage>
      </span>
    </div>
  );
}

const styles = (theme) => ({
  signInButton: {
    width: 310,
    height: 48,
    background: '#4285F4',
    borderRadius: 2,
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '17px',
    lineHeight: '23px',
    display: 'flex',
    alignItems: 'center',
    letterSpacing: 0.22712,
    color: '#FFFFFF',
    cursor: 'pointer',

    '&:hover': {
      filter: 'brightness(105%)'
    }
  },
  signInButtonIcon: {
    width: 44,
    height: 44,
    borderRight: '1px solid rgba(255, 255, 255, 0.5)',
    margin: '2px 24px 2px 2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: '20px auto',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    flex: 'none'
  },
  signInButtonText_es: {
    fontSize: 12
  },
  signInButtonText_pt: {
    fontSize: 15
  },
});

export default withStyles(styles)(SignInBtn);
